import React from "react";
import { Flex, Spin } from "antd";
const Loader = () => (
  <Flex
    align="center"
    gap="middle"
    style={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      zIndex: 10000,
    }}
  >
    <Spin size="large" />
  </Flex>
);
export default Loader;
